import * as React from 'react'

import { Box, Button, ColumnSplit, Text } from '@factorialco/deprecated-design-system'

import PanesHeader from 'modules/core/components/PanesHeader'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import type Schema from 'modules/custom_resources/store/models/customResources/Schema'

interface Props {
  schema: Schema
}

const CustomTableSettings = ({ schema }: Props) => {
  const { navigation } = useNavigation()

  return (
    <ColumnSplit colored={false}>
      <PanesHeader
        description={i18n.t('app_store_v2.apps.competencies_custom_table.settings.description')}
        illustration="window-user"
        line={false}
        title={i18n.t('app_store_v2.apps.competencies_custom_table.settings.title')}
      />
      <Box
        background="grey200"
        borderRadius={{
          all: 'abs008',
        }}
        gap="s16"
        padding="s24"
        width="full"
      >
        <Text.Normal>
          {i18n.t('app_store_v2.apps.competencies_custom_table.settings.content')}
        </Text.Normal>
        <Button.Router
          to={navigation.settings.customizations.customTablesId.fullPath({
            id: schema.attributes.id,
          })}
          type="secondary"
        >
          {i18n.t('app_store_v2.apps.competencies_custom_table.settings.button')}
        </Button.Router>
      </Box>
    </ColumnSplit>
  )
}

export default CustomTableSettings
